export default {
  GET_YEARS: (state) => state.years,
  GET_YEAR: (state) => state.year,
};
